module.exports = __webpack_public_path__ + "img/green-6-mb.a671a968.png";